import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Podcasts.css';

const Podcasts = () => {
  return (
    <>
      <Helmet>
        <title>Podcasts - Business & Finance Audio Shows | Redbox Global</title>
        <meta name="description" content="Listen to Redbox Global podcasts featuring expert insights on markets, technology, leadership, and global business. Audio content from industry leaders and journalists." />
        <meta name="keywords" content="business podcasts, finance podcasts, market analysis audio, leadership podcasts, tech podcasts, business audio, financial shows, podcast series" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/podcasts" />
        <meta property="og:title" content="Podcasts - Business & Finance Audio Shows | Redbox Global" />
        <meta property="og:description" content="Listen to expert insights on markets, technology, leadership, and global business from Redbox Global podcasts." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/podcasts" />
        <meta name="twitter:title" content="Podcasts - Business & Finance Audio Shows | Redbox Global" />
        <meta name="twitter:description" content="Listen to expert insights on markets, technology, leadership, and global business from Redbox Global podcasts." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/podcasts" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Podcasts</h1>
          <p className="page-subtitle">Expert insights on business, markets, and innovation through audio storytelling</p>
        </div>
        
        <div className="page-content">
          <a href="/article/markets-decoded-podcast" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=1200&h=600&fit=crop" alt="Podcast recording" />
              </div>
              <div className="featured-content">
               
                <h2>Markets Decoded: Your Daily Financial Brief</h2>
                <p>Join our expert analysts as they break down the day's biggest market moves, economic data, and investment opportunities. Get actionable insights delivered in just 20 minutes every weekday morning.</p>
                <span className="article-meta">Daily • 20 Minutes</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/innovation-chronicles-podcast" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=600&h=400&fit=crop" alt="Innovation podcast" />
                </div>
                <div className="article-content">
                
                  <h2>Innovation Chronicles</h2>
                  <p>Deep conversations with entrepreneurs and innovators changing the world through technology.</p>
                  <span className="article-meta">Weekly • 45 Minutes</span>
                </div>
              </article>
            </a>

            <a href="/article/leadership-matters-podcast" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop" alt="Leadership podcast" />
                </div>
                <div className="article-content">
                  
                  <h2>Leadership Matters</h2>
                  <p>CEOs and executives share their leadership philosophies and lessons learned.</p>
                  <span className="article-meta">Bi-Weekly • 35 Minutes</span>
                </div>
              </article>
            </a>

            <a href="/article/global-affairs-podcast" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?w=600&h=400&fit=crop" alt="Global affairs" />
                </div>
                <div className="article-content">
                  
                  <h2>The Global Agenda</h2>
                  <p>Understanding geopolitics, trade, and international business from expert correspondents.</p>
                  <span className="article-meta">Weekly • 30 Minutes</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Podcasts;
